<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Survey: {{ survey.survey_id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <strong class="text-uppercase" i18n>Survey Details</strong>

    <div class="row">
      <div class="col-4"><label i18n>Survey ID:</label></div>
      <div class="col-8">
        <label>{{ survey.survey_id }}</label>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-4"><label i18n>Survey Name:</label></div>
      <div class="col-8">
        <label>{{ survey.survey_name }}</label>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="col-4"><label i18n>Survey Type:</label></div>
      <div class="col-8">
        <label>{{ survey.survey_type }}</label>
      </div>
    </div>
    <br />

    <div *ngFor="let questions of survey.questions">
      <div class="row">
        <nb-accordion style="width: 100%">
          <nb-accordion-item style="width: 100%">
            <nb-accordion-item-header>
              <div class="col-auto mr-auto">
                <label i18n> Question: {{ questions.question_id }}</label>
              </div>
            </nb-accordion-item-header>
            <nb-accordion-item-body>
              <div class="row">
                <div class="col-4"><label i18n>Question ID:</label></div>
                <div class="col-8">
                  <label>{{ questions.question_id }}</label>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-4"><label i18n>Question Type:</label></div>
                <div class="col-8">
                  <label>{{ questions.question_type }}</label>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><label i18n>Question Name:</label></div>
                <div class="col-8">
                  <label>{{ questions.question_name }}</label>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><label i18n>Visible</label></div>
                <div class="col-8">
                  <nb-checkbox disabled name="visible" [(ngModel)]="questions.visible"></nb-checkbox>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><label i18n>Question Value:</label></div>
                <div class="col-8">
                  <label>{{ questions.value }}</label>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><label i18n>Question Image ID:</label></div>
                <div class="col-8">
                  <label>{{ questions.image_id }}</label>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><label i18n>Question Title ID:</label></div>
                <div class="col-8">
                  <label>{{ questions.title_id }}</label>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><label i18n>Question Subtitle ID:</label></div>
                <div class="col-8">
                  <label>{{ questions.subtitle_id }}</label>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-4"><label i18n>Question Display Order:</label></div>
                <div class="col-8">
                  <label>{{ questions.display_order }}</label>
                </div>
              </div>
              <br />

              <div *ngFor="let answers of questions.answers">
                <nb-accordion>
                  <nb-accordion-item>
                    <nb-accordion-item-header i18n>Answer: {{ answers.answer_id }}</nb-accordion-item-header>
                    <nb-accordion-item-body>
                      <div class="row">
                        <div class="col-4"><label i18n>Answer ID:</label></div>
                        <div class="col-8">
                          <label>{{ answers.answer_id }}</label>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-4"><label i18n>Answer Type:</label></div>
                        <div class="col-8">
                          <label>{{ answers.answer_type }}</label>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4"><label i18n>Value:</label></div>
                        <div class="col-8">
                          <label>{{ answers.value }}</label>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4"><label i18n>Value ID:</label></div>
                        <div class="col-8">
                          <label>{{ answers.value_id }}</label>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4"><label i18n>Minimum Value:</label></div>
                        <div class="col-8">
                          <label>{{ answers.min_value }}</label>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4">
                          <label i18n>Minimum Value Description:</label>
                        </div>
                        <div class="col-8">
                          <label>{{ answers.min_value_text }}</label>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4"><label i18n>Maximum Value:</label></div>
                        <div class="col-8">
                          <label>{{ answers.max_value }}</label>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4">
                          <label i18n>Maximum Value Description:</label>
                        </div>
                        <div class="col-8">
                          <label>{{ answers.max_value_text }}</label>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4">
                          <label i18n>Answer Image ID:</label>
                        </div>
                        <div class="col-8">
                          <label>{{ answers.image_id }}</label>
                        </div>
                      </div>
                      <br />

                      <div *ngFor="let actions of answers.actions">
                        <nb-accordion>
                          <nb-accordion-item>
                            <nb-accordion-item-header i18n>Action:</nb-accordion-item-header>
                            <nb-accordion-item-body>
                              <div class="row">
                                <div class="col-4">
                                  <label i18n>Action Type:</label>
                                </div>
                                <div class="col-8">
                                  <label>{{ actions.action_type }}</label>
                                </div>
                              </div>
                              <br />

                              <div class="row">
                                <div class="col-4">
                                  <label i18n>Action Value:</label>
                                </div>
                                <div class="col-8">
                                  <label>{{ actions.action_value }}</label>
                                </div>
                              </div>
                              <br />

                              <div class="row">
                                <div class="col-4"><label i18n>Deleted</label></div>
                                <div class="col-8">
                                  <nb-checkbox disabled name="visible" [(ngModel)]="actions.deleted"></nb-checkbox>
                                </div>
                              </div>
                              <br />

                              <div *ngIf="actions.action_payload">
                                <strong class="text-uppercase" i18n>Action Payload</strong>
                                <div class="row">
                                  <div class="col-4">
                                    <label i18n>Deleted</label>
                                  </div>
                                  <div class="col-8">
                                    <nb-checkbox
                                      disabled
                                      name="visible"
                                      [(ngModel)]="actions.action_payload.deleted"
                                    ></nb-checkbox>
                                  </div>
                                </div>
                                <br />

                                <div class="row">
                                  <div class="col-4"><label i18n>URL:</label></div>
                                  <div class="col-8">
                                    <label>{{ actions.action_payload.url }}</label>
                                  </div>
                                </div>
                                <br />
                              </div>
                            </nb-accordion-item-body>
                          </nb-accordion-item>
                        </nb-accordion>
                      </div>
                    </nb-accordion-item-body>
                  </nb-accordion-item>
                </nb-accordion>
              </div>
            </nb-accordion-item-body>
          </nb-accordion-item>
        </nb-accordion>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton status="info" (click)="close()" i18n>Close</button>
    </div>
  </nb-card-footer>
</nb-card>
